<template>
<section class="trainer">
  <div class="trainer__header">
    <div class="trainer__info train__info" v-show="isStarted">
      <div class="train__item" v-if="$route.params.isHomework" uk-tooltip="Выполнено упражнений">
				<div class="train__ico train__ico--4"></div>
				<small>Выполнено:</small>
				<div class="train__nowrap">{{ $route.params.total }} из {{ $route.params.qnt }}</div>
			</div>
      <div class="train__item" uk-tooltip="Ошибок">
        <div class="train__ico train__ico--2"></div>
        <small>Ошибок:</small>
        {{ errors }}
      </div>
      <div class="train__item" uk-tooltip="Времени прошло" v-show="!gameParams.noTimer">
        <div class="train__ico train__ico--3"></div>
        <div>
          <small>Времени прошло:</small>
          <Timer 
            :time="gameParams.timer" 
            ref="timer" 
            @stop="showResult($event, false)"
          />
        </div>
      </div>      
    </div>
    <a href="#" class="trainer__stop-btn" @click.prevent="stop" v-show="isStarted">Остановить</a>

    <div class="trainer__start" v-show="!isStarted">
      <Timer 
        class="countdown"
        :time="gameParams.startTime" 
        ref="countdown" 
        @stop="startGame"
      />
    </div>
  </div>
  
  <div class="trainer__body">
    <ul class="cards">
      <Card 
        v-for="(card, i) in randomCards" 
        :key="card.name + i" 
        :card="card" 
        @add-card="addCard"
        :number="i + 1"
        :style="`width: ${cardSize.width}px; height: ${cardSize.height}px`"
      />
    </ul>
  </div>
</section>
</template>

<script>
import { cardSound, successSound, playSuccess } from './sounds'
import Card from './Card.vue'
import Timer from '../../../../other/Timer.vue'
export default {
  components: {
    Card,
    Timer
  },
  props: ['params', 'cards'],
  data() {
    return {
      isStarted: false,
      cardSound,
      successSound,
      randomCards: [],
      cardsToCompare: [],
      gameParams: {},
      errors: 0,
      container: null
    }
  },
  computed: {
    // размер картинок в зависимости от их количества и высоты экрана
    cardSize() {
      let height = 162
      let width = 240
      if (this.container) {
        const containerHeight = this.container.offsetHeight

        let cards = this.randomCards.length
        if (window.screen.width > 640) {
          switch(true) {
            case cards < 10:          
              height = containerHeight / 4.5
              break
            case cards < 14:          
              height = containerHeight / 5
              break
            case cards <= 16:          
              height = containerHeight / 6
              break
          }
        } else {
          height = 80
        }

        width = height * 1.5
      } 

      return {
        width,
        height
      }  
    }
  },
  methods: {
    playSuccess,
    stop() {
      this.$emit('stop')
      if (this.$route.params.isHomework) {
        this.$router.go(-1)
      }
    },
    addCard(card) {
      if (this.cardsToCompare.length < 2 && !card.isShow) {        
        card.isShow = true
        this.cardsToCompare.push(card)

        if (this.gameParams.sounds) {
          this.cardSound.play()
        }

        if (this.cardsToCompare.length === 2) {
          this.checkCards()
        }
      }
    },
    checkCards() {
      let card1 = this.cardsToCompare[0]
      let card2 = this.cardsToCompare[1]

      if (card1.name === card2.name) {
        
        setTimeout(() => {
          card1.isComplete = true
          card2.isComplete = true
          this.cardsToCompare = []
          this.checkResult()

          if (this.gameParams.sounds) {
            this.playSuccess()
          }
        }, 400)
      } else {
        this.errors++
        setTimeout(() => {
          this.cardsToCompare = []
          this.hideCards()
        }, 1200)
      }
    },
    hideCards() {
      let cards = this.randomCards.filter(item => !item.isComplete)
      cards.forEach(item => item.isShow = false)
    },
    getRandomCards() {
      let count = this.gameParams.cards / 2
      let arr = this.cards.filter(item => {
        let random_boolean = Math.random() < 0.5;
        if (random_boolean && count > 0) {
          count--
          return item
        }
      })
      let copy = arr.slice()
      // добавляем пару

      copy.forEach(card => {
        let secondCard = Object.assign({}, card)
        let random_index = Math.random() * (arr.length - 0) + 0;
        arr.splice(random_index, 0, secondCard)
      })

      return arr
    },
    checkResult() {
      let uncompleteItem = this.randomCards.find(item => !item.isComplete)

      if (!uncompleteItem) {
        this.showResult(this.$refs.timer.elapsedTimeData, true)
      }
    },
    showResult(elapsed, isSuccess) {
      let data = {
        isSuccess
      }
      data.elapsedTime = elapsed
      data.errors = this.errors
      this.$emit('show-result', data)      
    },
    startGame() {
      this.isStarted = true
      this.hideCards()
      
      if (!this.gameParams.noTimer) {
        this.$refs.timer.start()
      }
    }
  },
  created() {
    this.gameParams = Object.assign({}, this.params)
    this.randomCards = this.getRandomCards()
  },
  mounted() {
    if (this.gameParams.startTime) {
      this.$refs.countdown.start()
    } else {
      this.startGame()
    } 
    document.body.style.overflow = 'hidden'
    
    const trainer = document.querySelector('.trainer')
    window.scrollTo({
      top: trainer.offsetTop,
      behavior: "smooth"
    })

    this.container = trainer
  },
  beforeDestroy() {
    document.body.style.overflow = 'auto'
    this.cards.forEach(item => {
      item.isComplete = false
      item.isShow = true
    })
  }
}
</script>

<style lang="scss" scoped>
.cards {
  list-style: none;
  padding: 0;
  padding-bottom: 10px;
  margin-top: 40px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  flex-grow: 1;
}

.countdown {
  font-size: 42px;
  color: #f89623;
}

.game {
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  overflow: auto;
  z-index: 20;
}
.game__body {
  flex-grow: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
}
</style>
